<label>{{ 'pagePaymentAndContact.duitNow.confirmPayee' | translate }}</label>
<form [formGroup]="duitNowForm">
    <div class="form-group">
        <qnect-ui #DUITNOW_PAYEE_ID_TYPE [fieldId]="'DUITNOW_PAYEE_ID_TYPE'" [formGroup]="duitNowForm"
                  [dynamicOptions]="payeeIdTypeOptions"
                  [hidden]="transactionInfo.isGenericClaim() && isCorporate && isPolicyHolderIdUsed"
                  name="payeeIdType"></qnect-ui>
    </div>
    <div class="form-group">
        <qnect-ui #DUITNOW_PAYEE [fieldId]="'DUITNOW_PAYEE'" [formGroup]="duitNowForm" [dynamicOptions]="payeeOptions"
                  [type]="showPayeeTextField ? 'textfield' : 'dropdownSelect'" [disabled]="showPayeeTextField ? 'true' : 'false'"
                  name="payee"></qnect-ui>
    </div>
    <div class="form-group">
        <label style="font-size: 18px;">{{claim.getProxyIdTypeDesc()}}*</label>
        <qnect-ui #DUITNOW_PAYEE_ID [fieldId]="'DUITNOW_PAYEE_ID'" [formGroup]="duitNowForm"
                   name="payeeId"></qnect-ui>
    </div>
    <div class="form-group" *ngIf="claim.getProxyIdType()?.toLowerCase() === 'passport'">
        <qnect-ui #DUITNOW_COUNTRY_PASSPORT [fieldId]="'DUITNOW_COUNTRY_PASSPORT'" [formGroup]="duitNowForm"
                  name="countryPassport"></qnect-ui>
    </div>
</form>
<div class="info-box">
    <div class="info-content">
        <i class="info-hits"></i>
        <div class="info-text">
            <p class="info-title">{{'pagePaymentAndContact.duitNow.infoTitle' | translate}}</p>
            <p class="info-message">{{'pagePaymentAndContact.duitNow.infoMessage' | translate}}</p>
        </div>
    </div>
</div>
